import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import { router } from "@/router";
import CenterTop from '@/components/layout/CenterTop.vue';
import AuthItemsTable from '@/components/authItem/AuthItemsTable.vue';
import GridLayout from '@/components/layout/GridLayout.vue';
import GridItem from '@/components/layout/GridItem.vue';
import Card from '@/components/layout/Card.vue';
import AuthItemPreview from '@/components/authItem/AuthItemPreview.vue';
import { AUTH_ITEM_PUBLIC_LIST } from '@/store/actions/authItem';
import { AUTH_LINK_EMPTY_LIST } from '@/store/actions/authLink';
import { redirectToIDP } from '@/utils/util';
var IdpChoose = /*#__PURE__*/function (_Vue) {
  function IdpChoose() {
    var _this;
    _classCallCheck(this, IdpChoose);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IdpChoose, [].concat(args));
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "token", '');
    _defineProperty(_this, "asc", '');
    _defineProperty(_this, "authItemIDSelected", '');
    _defineProperty(_this, "originalPlatform", void 0);
    return _this;
  }
  _inherits(IdpChoose, _Vue);
  return _createClass(IdpChoose, [{
    key: "authItems",
    get: function get() {
      return store.getters.authItems;
    }
  }, {
    key: "beforeCreate",
    value: function beforeCreate() {
      store.commit(AUTH_LINK_EMPTY_LIST);
    }
  }, {
    key: "created",
    value: function created() {
      this.loading = true;
      if (this.$route.query.token) {
        this.token = this.$route.query.token + '';
        this.asc = this.$route.query.asc + '';
        this.authItemIDSelected = this.$route.query.authItemID + '';
      }
      // we save the original platform if its exist, to choose automatically the team
      if (this.$route.query.platform != null) {
        this.originalPlatform = this.$route.query.platform;
      }
      // if we have a token, we have to go to the choose Team page
      if (this.token !== '') {
        router.push({
          name: 'authLinkConnect',
          params: {
            authItemID: this.authItemIDSelected,
            token: this.token,
            asc: this.asc,
            originalPlatform: this.originalPlatform
          }
        });
      } else {
        this.loadPublicAuthItem();
      }
    }
  }, {
    key: "loadPublicAuthItem",
    value: function loadPublicAuthItem() {
      var _this2 = this;
      // we load the list of cluster
      store.dispatch(AUTH_ITEM_PUBLIC_LIST, this.originalPlatform).then(function () {
        var listOfAuthItems = Object.keys(_this2.authItems);
        if (Object.keys(_this2.authItems).length === 1) {
          redirectToIDP(_this2.authItems[listOfAuthItems[0]]);
        } else {
          _this2.loading = false;
        }
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }]);
}(Vue);
IdpChoose = __decorate([Options({
  components: {
    AuthItemPreview: AuthItemPreview,
    CenterTop: CenterTop,
    Card: Card,
    GridItem: GridItem,
    GridLayout: GridLayout,
    AuthItemsTable: AuthItemsTable,
    MainTitle: MainTitle
  }
})], IdpChoose);
export default IdpChoose;